//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Preview from '@/components/public-components/image-preview/index'
import Footer from "@/components/lyx-components/lyx-footer/index"
import bus from '@/javascript/bus'
import goBack from '@/components/public-components/goBack/index.vue'
export default {
  components: {
    Preview,
    Footer,
    goBack
  },
  data () {
    return {
      minHeight: 0,
      image: [],
      lookMoreShow: true,
      lookMore: true,
      extendMap: {},
      detail: {},//详情页细节
      isFoodDetail: false
    }
  },
  // async mounted() {
  //     this.minHeight = document.documentElement.clientHeight - this.$refs.footer.$el.offsetHeight
  //     const { params } = this.$route;
  //     const { id, type } = params;
  //     if (type === 'X') {
  //       this.isFoodDetail = true
  //     }
  //     const res = await this.getDeatail(id);
  //     if( res.msg == 'success' ){
  //         const { news, extendMap, newsMaterials } = res.data;
  //         const { description } = news;
  //         this.detail = news;
  //         this.extendMap = extendMap;
  //         this.image = newsMaterials.map(el => {
  //           el.src = this.PIC_BASE_URL + el.fileUrl;
  //           return el;
  //         });
  //         // console.log(this.image)
  //         if(description.length > 50){
  //           Object.assign( this.detail, {
  //             lessDes: description.substring(0,50) + '...'
  //           })
  //         }
  //         document.title = this.detail.title
  //     }
  // },
  methods: {
    moreMsg (lookMore) {
      if (lookMore) {
        this.lookMore = false;
      } else {
        this.lookMore = true;
      }
    },
    // async getDeatail(id){
    //   //获取特产的详情页数据
    //   return request({
    //     url: `api/wtcp-cms/public/news/${id}`,
    //     method: 'get'
    //   })
    // }

    // 获取详情
    getDatil () {

      this.$http.get('api/wtcp-bics/public/periphery/' + this.$route.params.id)
        .then((res) => {
          res.data.data.fileList.image.all.materials.forEach(item => {
            let temp = {};
            this.$set(temp, 'fileUrl', item.fileUrl);
            this.$set(temp, 'src', this.PIC_BASE_URL + temp.fileUrl);
            this.image.push(temp);
          });
          this.detail = res.data.data;
          if (this.detail.description.length > 50) {
            Object.assign(this.detail, {
              lessDes: this.detail.description.substring(0, 50) + '...'
            })
          } else {
            this.isFoodDetail = true
          }
          document.title = this.detail.title;
          // 历史记录，未登录状态待完善
          if (bus.userInfo.user) {
            const userInfo = bus.userInfo.user,
              history = {
                catalog: this.XQSC_TYPE_CODE.CY,
                serviceType: this.SERVICE_TYPE.CY,
                title: res.data.data.title,
                url: this.$route.path,
                userId: userInfo.id,
                username: userInfo.username,
                picUrl: res.data.data.fileList.image.all.materials[0].fileUrl
                //   || scenicData.fileList.image.all.materials[0].fileUrl
              }
            bus.$set(bus, 'history', history)
          } else {
            console.log('token过期了呀');
          }
        })
    },

  },
  mounted () {
    this.minHeight = document.documentElement.clientHeight - this.$refs.footer.$el.offsetHeight;
    if (this.$route.params.kind === 'T') {
      this.isFoodDetail = true
    }
    this.getDatil();
  }
}
